import React, { useEffect } from 'react'
import PropTypes from 'prop-types'

import MenuGroups from './MenuGroups/MenuGroups'
import { ViewableMonitor } from '../ViewableMonitor/ViewableMonitor'
import { useMenuSelection } from '../../hooks/use-menu-selection'
import { NoMenus } from './NoMenus'

import './Menus.css'

export const MenusInner = ({ menu, isIntersecting, refMap, showHeading }) => {
  const { id, name, groups } = menu
  const setActiveMenu = useMenuSelection()
  useEffect(() => {
    if (isIntersecting) {
      setActiveMenu(id)
    }
  }, [isIntersecting, id, setActiveMenu])
  return (
    <React.Fragment >
      {showHeading && (
        <React.Fragment>
          <h2 styleName='title'>{name}</h2>
          <hr styleName='rule' />
        </React.Fragment>
      )}
      <MenuGroups menuGroups={groups} refMap={refMap} />
    </React.Fragment>
  )
}

MenusInner.propTypes = {
  menu: PropTypes.object,
  isIntersecting: PropTypes.bool.isRequired,
  refMap: PropTypes.object.isRequired,
  showHeading: PropTypes.bool.isRequired
}

export const Menus = ({ menus, refMap, menuGroups, showAllMenus }) => {
  if (showAllMenus) {
    const showHeading = menus.length > 1
    return menus.length > 0
      ? menus.map(menu => (
        <ViewableMonitor rootMargin={'-15% 0px -85% 0px'} key={menu.id}>
          {(isIntersecting) =>
            <MenusInner isIntersecting={isIntersecting} menu={menu} refMap={refMap} showHeading={showHeading} />
          }
        </ViewableMonitor>
      ))
      : <NoMenus />
  }
  return menuGroups.length > 0
    ? <MenuGroups menuGroups={menuGroups} refMap={refMap} />
    : <NoMenus />
}

Menus.propTypes = {
  menus: PropTypes.array,
  refMap: PropTypes.object.isRequired,
  menuGroups: PropTypes.array,
  showAllMenus: PropTypes.bool.isRequired
}
